import { useState } from "react";

// The form's snackbar message (validation errors, image limits, failed sends)
export const useSnackbarMessage = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return { snackbar, setSnackbar, handleCloseSnackbar };
};
